import React, { useState } from "react";
import { ICON_NAMES, getIcon } from "@/lib/icons";
import { ChevronDown } from "lucide-react";

export default function IconPicker({ value, onChange, label = "Icon" }) {
  const [open, setOpen] = useState(false);
  const Active = getIcon(value);
  return (
    <div className="relative">
      <label className="font-inter text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mt-1.5 w-full flex items-center justify-between bg-white rounded-xl border border-slate-200 px-3 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-4 focus:ring-[#73c3ff]/30 focus:border-[#73c3ff] transition"
      >
        <span className="flex items-center gap-2">
          <Active className="w-4 h-4 text-[#002570]" />
          <span className="font-mono text-xs">{value || "Sparkles"}</span>
        </span>
        <ChevronDown className="w-4 h-4 text-slate-400" />
      </button>
      {open && (
        <div className="absolute z-30 mt-2 w-full max-h-60 overflow-y-auto bg-white border border-slate-200 rounded-xl shadow-xl p-2 grid grid-cols-6 gap-1">
          {ICON_NAMES.map((n) => {
            const I = getIcon(n);
            return (
              <button
                key={n}
                type="button"
                title={n}
                onClick={() => { onChange(n); setOpen(false); }}
                className={`aspect-square flex items-center justify-center rounded-lg hover:bg-slate-100 ${value === n ? "bg-[#002570] text-white" : "text-slate-700"}`}
              >
                <I className="w-4 h-4" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
